// 规则参数分隔符
export const RULE_PARAMS_SEPARATOR = ','

// 关联字段分隔符
export const RELATED_FIELD_SEPARATOR = '@'
